import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-ink"><div className="max-w-3xl mx-auto px-6 py-24 pt-36 text-muted leading-relaxed">
      <h1 className="font-display text-[clamp(36px,6vw,64px)] leading-none tracking-wide text-paper mb-6">
        Privacy Policy for Deep-c Vision
      </h1>
      <p><strong>Effective Date:</strong> 30 June 2025</p>

      <p className="mt-4">
        Deep-c Vision ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information when you visit our website at{" "}
        <a href="https://deepcvision.co.uk" className="text-brand-cyan hover:underline" target="_blank" rel="noopener noreferrer">
          https://deepcvision.co.uk
        </a>.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">1. Information We Collect</h2>
      <h3 className="font-medium text-paper mt-6 mb-1">a) Personal Data You Provide:</h3>
      <ul className="list-disc pl-6">
        <li>Name, email address, or contact details</li>
        <li>Information you voluntarily share through our services or communication</li>
      </ul>

      <h3 className="font-medium text-paper mt-6 mb-1">b) Automatically Collected Data:</h3>
      <ul className="list-disc pl-6">
        <li>IP address</li>
        <li>Browser type and version</li>
        <li>Device identifiers</li>
        <li>Pages visited and interaction data</li>
        <li>Time and date of your visit</li>
      </ul>

      <h3 className="font-medium text-paper mt-6 mb-1">c) Cookies and Tracking Technologies:</h3>
      <p>
        We may use cookies and similar technologies to enhance your experience. You can manage or block cookies through your browser settings.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">2. How We Use Your Information</h2>
      <ul className="list-disc pl-6">
        <li>Respond to inquiries or customer service requests</li>
        <li>Improve website performance and user experience</li>
        <li>Analyze usage patterns and website traffic</li>
        <li>Send updates or marketing communications (only with your consent)</li>
      </ul>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">3. Legal Basis for Processing</h2>
      <ul className="list-disc pl-6">
        <li>Your consent (e.g., when you submit a form)</li>
        <li>Performance of a contract</li>
        <li>Compliance with a legal obligation</li>
        <li>Legitimate interests (e.g., to improve the website)</li>
      </ul>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">4. Sharing Your Information</h2>
      <p>
        We do <strong>not</strong> sell or rent your data. We may share your information with trusted third-party service providers under confidentiality agreements.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">5. Data Retention</h2>
      <p>
        We retain your personal information only as long as necessary or as required by law.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">6. Your Rights</h2>
      <ul className="list-disc pl-6">
        <li>Access, correct, or delete your data</li>
        <li>Object to processing or request restriction</li>
        <li>Withdraw consent at any time</li>
        <li>Complain to the ICO:{" "}
          <a href="https://ico.org.uk/" className="text-brand-cyan hover:underline" target="_blank" rel="noopener noreferrer">
            https://ico.org.uk/
          </a>
        </li>
      </ul>
      <p>Email us at{" "}
        <a href="mailto:contact@deepcvision.co.uk" className="text-brand-cyan hover:underline">
          contact@deepcvision.co.uk
        </a>
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">7. Data Security</h2>
      <p>
        We use encryption and access controls to protect your data.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">8. Third-Party Services and Links</h2>
      <p>
        We are not responsible for third-party privacy practices. Review their policies separately.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">9. International Data Transfers</h2>
      <p>
        If we transfer data outside the UK or EEA, we use appropriate safeguards (e.g., SCCs).
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">10. Changes to This Policy</h2>
      <p>
        We may update this policy and post the new version with an updated date.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">11. Contact Us</h2>
      <p>
        <strong>Deep-c Vision</strong><br />
        Website:{" "}
        <a href="https://deepcvision.co.uk" className="text-brand-cyan hover:underline" target="_blank" rel="noopener noreferrer">
          https://deepcvision.co.uk
        </a><br />
        Email:{" "}
        <a href="mailto:contact@deepcvision.co.uk" className="text-brand-cyan hover:underline">
          contact@deepcvision.co.uk
        </a>
      </p>

      <button
        onClick={() => navigate(-1)}
        className="bg-primary-purple text-white text-sm font-semibold mt-10  px-4 py-3 rounded-btn z-50 "
      >
        ← Back
      </button>
    </div></div>
  );
};

export default PrivacyPolicy;
